import IPredictedFlowGrouperList from '../interfaces/groupers/IPredictedFlowGrouperList';

export default class PredictedFlowChildrenItemsHelper {
  public static getChildrenByFatherItems(
    selectedIndex: number,
    items: IPredictedFlowGrouperList[],
): IPredictedFlowGrouperList[] {
    const initialItem = items[selectedIndex];
    const childrens = [];
    for (let index = selectedIndex; index < items.length; index += 1) {
        const element = items[index];

        if (element.level <= initialItem.level && index !== selectedIndex) {
            break;
        }

        if (element.level === 4) {
            childrens.push({
              ...element,
              index,
            });
        }
    }

    return childrens;
  }
}
